<template>
  <div>

  </div>
</template>

<script>

export default {
  name: "Sessions_Chat",
  components: {

  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {},
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>
